export enum LastFlowEnum {
  joinus = "joinus",
  community = "community",
}
